import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useState } from "react";
import { deleteAllCookies } from "../../utils/Utils";
import { toast } from "react-toastify";
import { toastResponse } from "../../Components/Common/Toast/Toast";
import { globalError } from "../../utils/global-error-handler";
import { setErrorType } from "../../Redux/errorSlice";
import { HttpStatusCode } from "axios";

export const RTK_CONSTANT = {
  REFETCH_CARDS: false,
  REFETCH_TRENDS: true,
  POLLINF_INTERVAL: 1000 * 60 * 60,
};

const handle400Error = ({
  error,
  errorCount400,
  setErrorCount400,
  navigate,
}) => {
  if (errorCount400 !== 0) return;
  setErrorCount400(errorCount400 + 1);
  if (!error?.data?.error?.includes("USER_NOT_FOUND")) return;
  deleteAllCookies();
  globalThis.history.pushState({}, "", "/user/clearsession");
  navigate("/user/login", { state: { directLogout: true } });
};

const handleNon400Error = ({ error, errorReducer, dispatch }) => {
  if (errorReducer?.errorType?.includes(error.status)) return false;
  dispatch(setErrorType(error.status));
  if (error.status === HttpStatusCode.Unauthorized) return true;
  toast.error(
    toastResponse(
      "error",
      globalError({
        data: {
          data: "",
          error: error.status,
          message: error?.error,
          status: "ERROR",
        },
      }).message,
    ),
  );
  return false;
};

const useFetch = (
  useQuery,
  { refetchOnMountOrArgChange, skip, selectFromResult, queryParams },
) => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const orgReducer = useSelector((state) => state?.orgReducer);
  const currentDashboard = useSelector(
    (state) => state.dashboardReducer.currentDashboard,
  );
  const errorReducer = useSelector((state) => state?.errorReducer);
  const subscriptionReducer = useSelector(
    (state) => state?.subscriptionReducer,
  );
  const orgId = orgReducer?.selectedFI?.orguid
    ? orgReducer?.selectedFI?.orguid
    : orgReducer?.selectedFI?.orgKey;
  const hasAuthToken = Boolean(authReducer?.userData?.accessToken);
  const shouldSkipQuery =
    !authReducer?.isLogin || !hasAuthToken || !orgId || skip;
  const params = useParams();
  const subtype = subscriptionReducer?.isPro ? "default" : "trial";
  const navigate = useNavigate();
  const [errorCount400, setErrorCount400] = useState(0);

  const headers = {
    Authorization: `${authReducer?.userData?.tokenType?.toLowerCase()} ${
      authReducer?.userData?.accessToken
    }`,
    "Content-Type": "application/json",
  };

  const payload = {
    filter: {},
    requid: params?.hid === "no-analysis-id" ? "" : params?.hid,
    producttype: currentDashboard?.KEY,
    gte: "",
    lte: "",
    duration: "",
  };

  const { data, isError, isLoading, error } =
    payload != null &&
    useQuery(
      {
        orgId,
        headers,
        payload,
        subtype,
        queryParams,
      },
      selectFromResult == undefined
        ? {
            pollingInterval: RTK_CONSTANT.POLLINF_INTERVAL,
            refetchOnMountOrArgChange,
            skip: shouldSkipQuery,
          }
        : {
            refetchOnMountOrArgChange,
            skip: shouldSkipQuery,
            selectFromResult: selectFromResult,
          },
    );

  if (isError) {
    if (error.status === 400) {
      handle400Error({ error, errorCount400, setErrorCount400, navigate });
    } else if (handleNon400Error({ error, errorReducer, dispatch })) {
      return { data, isError, isLoading, error };
    }
  }

  return { data, isError, isLoading, error };
};
export default useFetch;
